import { retrieveCompanyMaster } from "./company.datasource";

export async function getCompanyMaster() {
    try {
        const response = (await retrieveCompanyMaster()).data;

        return response;
    } catch (error) {
        throw error;
    }
}